import React, { useState } from "react";
import StudentPausePopup from "../StudentPausePopup";
import { useStyles } from "./style";
import ActionButtons from "../ActionButtons";
import moment from "moment-timezone";
import ClassesResumedSuccessModal from "../ClassesResumedSuccessModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setAlreadyPauseModalOpen,
  setDateRange,
} from "../../../Redux/slices/studentPauseSlice";
import { Spinner } from "react-bootstrap";
import { API } from "../../../Services/api-services";
import { toast } from "react-toastify";
toast.configure();

const StudentAlreadyPausedModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isAlreadyPausedModalOpen = useSelector(
    (state) => state.studentPause.isAlreadyPauseModalOpen
  );
  const pauseModalData = useSelector(
    (state) => state.studentPause.pauseModalData
  );
  const dateRange = useSelector((state) => state.studentPause.dateRange);

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const formatDate = (date) => {
    const formattedDate = moment(date).format("DD/MM/YYYY");
    return formattedDate;
  };
  const startAndEndDate = [
    {
      label: "Start date -",
      value: dateRange.startDate,
    },
    {
      label: "End date -",
      value: dateRange.endDate,
    },
  ];

  const handleCancel = () => {
    dispatch(setAlreadyPauseModalOpen(false));
    dispatch(setDateRange({}));
  };
  const handleResumeClasses = async () => {
    setLoader(true);
    try {
      await API.post("/student/pause/resume", {
        ...pauseModalData,
        resumeBeforeStart: true,
      });
      setIsSuccessModalOpen(true);
      dispatch(setAlreadyPauseModalOpen(false));
      dispatch(setDateRange({}));
    } catch (error) {
      console.error("Error resuming classes:", error);
      toast.error(error?.response?.data?.msg, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setLoader(false);
      handleCancel();
    }
  };
  return (
    <>
      <ClassesResumedSuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
      />

      <StudentPausePopup open={isAlreadyPausedModalOpen}>
        {loader ? (
          <div className={classes.loaderContainer}>
            <Spinner animation="border" variant="#FF712D" />
          </div>
        ) : (
          <div className={classes.StudentAlreadyPausedContainer}>
            <div className={classes.pauseDetailContainer}>
              <p className={classes.pauseHeading}>Student is paused</p>
              <p className={classes.pauseDescription}>
                Resume student to perform operations. Paused for below date
              </p>
              <div className={classes.dateRangeContainer}>
                {startAndEndDate.map((date, index) => (
                  <div key={index} className={classes.dateRange}>
                    <p className={classes.dateLabel}>{date.label}</p>
                    <p className={classes.dateValue}>
                      {formatDate(date.value)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <ActionButtons
              proceedBtnText={"Resume Classes"}
              cancelBtnText={"Cancel"}
              handleCancel={handleCancel}
              handleProceed={handleResumeClasses}
            />
          </div>
        )}
      </StudentPausePopup>
    </>
  );
};

export default StudentAlreadyPausedModal;
